export interface WeekDay {
  label: string
  date: string // ISO date string e.g. "2026-03-16"
  day: number // numeric day for display e.g. 16
  isToday?: boolean
  hasEntries?: boolean
}

interface WeekStripProps {
  days: WeekDay[]
  selectedDate?: string // ISO date string
  onSelectDate?: (date: string) => void
}

export function WeekStrip({
  days,
  selectedDate,
  onSelectDate,
}: WeekStripProps) {
  return (
    <div className="mb-5 flex items-center justify-between">
      {days.map((day) => {
        const isToday = day.isToday
        const isSelected = selectedDate === day.date

        return (
          <button
            key={day.date}
            type="button"
            className="week-day flex flex-col items-center gap-1.5 border-none bg-transparent"
            onClick={() => onSelectDate?.(day.date)}
            aria-label={`${day.label} ${day.day}${isToday ? " (today)" : ""}`}
          >
            <span
              className={`text-[11px] ${isToday ? "text-fig-text-primary font-semibold" : "text-fig-text-inactive font-medium"}`}
            >
              {day.label}
            </span>
            <div
              className={`flex size-9 items-center justify-center rounded-full text-[14px] ${
                isToday || isSelected ? "font-bold" : "font-semibold"
              }`}
              style={{
                background: isToday
                  ? "var(--fig-week-today-bg)"
                  : isSelected
                    ? "var(--fig-week-selected-bg)"
                    : undefined,
                outline:
                  isSelected && !isToday
                    ? "2.5px solid var(--fig-week-selected-ring)"
                    : undefined,
                color: isToday
                  ? "var(--fig-week-today-text)"
                  : day.hasEntries
                    ? "var(--fig-text-primary)"
                    : "var(--fig-text-placeholder)",
              }}
            >
              {day.day}
            </div>
            <div
              className="size-1.5 rounded-full"
              style={{
                background: day.hasEntries
                  ? "var(--fig-week-dot-active)"
                  : "var(--fig-week-dot-empty)",
              }}
            />
          </button>
        )
      })}
    </div>
  )
}
